import React, { useState, useEffect } from 'react';
import styles from '../css/dynamicCSS.less';
import { getDynamicPage } from '@/utils/requests/camp/requests_dynamic';
import { DynamicType } from '@/types/camp/dynamic/dynamicType';
import DynamicItem from './dynamicItem';
import { InfiniteScroll } from 'antd-mobile';
import wenhaoPng from '@/static/images/wenhao.png';

interface props {
  selected: number;
  size?: number;
  campId?: string | null;
  batchId?: string;
  nodeIds?: string[];
  startText?: string;
  hide?: boolean;
  setTabKey?: (tabKey: string) => void;
  isFirst?: boolean;
}
const Dynamic: React.FC<props> = (props) => {
  const [dataList, setDataList] = React.useState<DynamicType[]>([]);
  const [current, setCurrent] = useState<number>(1);
  const [total, setTotal] = useState<number>(1);
  const [hasMore, setHasMore] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(true);
  const [hash, setHash] = React.useState<number>();

  // 获取动态分页
  const getPageRun = (newRun: boolean = false, clean: boolean = false) =>
    getDynamicPage({
      campId: props.campId || '',
      batchId: props.batchId || '',
      nodeIds: props.nodeIds || [],
      selected: props.selected,
      hide: props.hide,
      current: newRun ? 1 : current,
      size: props.size ? props.size : 10,
    })
      .then((res: any) => {
        // 没有精选切换所有动态
        if (props && typeof props.setTabKey === 'function') {
          if (props.isFirst && props.selected === 1) {
            // props.setTabKey(res.data.total === 0 ? '2' : '1');
            if (res.data.total === 0) {
              props.setTabKey('2');
            }
          }
        }
        setTotal(res.data.total);
        if (dataList && !clean) {
          setDataList([...dataList, ...res.data.records]);
        } else {
          setDataList([...res.data.records]);
        }
        setCurrent(newRun ? 1 : current + 1);
        setTotal(res.data.total);
        setHasMore(res.data.current < res.data.pages);
      })
      .finally(() => {
        setLoading(false);
      });

  const InfiniteScrollContent = ({ hasMore }: { hasMore?: boolean }) => {
    return (
      <>
        {hasMore ? (
          <>
            <div></div>
          </>
        ) : total > 0 ? (
          <span>—— 没有更多了 ——</span>
        ) : (
          ''
        )}
      </>
    );
  };

  useEffect(() => {
    if (hash) {
      getPageRun(true);
    }
  }, [hash]);

  useEffect(() => {
    props.nodeIds && props.nodeIds?.length > 0 && getPageRun(true, true);
  }, [props.nodeIds]);

  return (
    <>
      <div className={styles.dynamic_box_main}>
        {dataList.length > 0
          ? dataList.map((item, index) => (
              <DynamicItem key={index} item={item} index={index} setHash={setHash} />
            ))
          : !loading && (
              <div className="flex_4_1" style={{ padding: '60px 0 100px' }}>
                <img src={wenhaoPng} width={200} height={200} />
                <div className="col808">快来成为第一个评论的人</div>
              </div>
            )}
      </div>
      <InfiniteScroll loadMore={getPageRun} hasMore={hasMore}>
        <InfiniteScrollContent hasMore={hasMore} />
      </InfiniteScroll>
    </>
  );
};
export default Dynamic;
